module.exports = __webpack_public_path__ + "static/media/credit-card.8fa464b4.svg";